import { createSelector } from '@reduxjs/toolkit'

import { selectPlanningWizardState } from './selectPlanningWizardState'

export const selectIsHideWizard = createSelector(
  [selectPlanningWizardState],
  (state) => state.isHideWizard
)
